import operations from './operations';
import registerLive from './registerLive';
import * as selectors from '../selectors/users';

export default {
  operations,
  selectors,
  registerLive: registerLive(operations),
};
